<template>
  <div>
    <!-- Display Image & Price -->
    <div class="pb-2">
      <item-info-container
        :imageURL="appointmentHistory.serviceImage"
        :salePrice="appointmentHistory.servicePrice"
        :hidePrice="hidePriceConditional"
        :name="appointmentHistory.serviceName"
      />
    </div>

    <div class="p-4 text-start">
      <span class="mb-5" v-if="appointmentHistory.description">
        {{ appointmentHistory.description }}
      </span>
      <div class="d-flex flex-row">
        <div class="d-flex flex-column scss-bold w-25">
          <span>Date:</span>
          <span>Time:</span>
          <span>Duration:</span>
          <span>Booked:</span>
          <span>Outlet:</span>
          <span>Status:</span>
        </div>

        <div class="d-flex flex-column flex-grow-1 text-end text-truncate w-75">
          <span class="text-truncate">{{ appointmentHistory.date }}</span>
          <span class="text-truncate">{{ appointmentHistory.time }}</span>
          <span class="text-truncate">{{ appointmentHistory.duration }}</span>
          <span class="text-truncate">{{ appointmentHistory.staffName }}</span>
          <span class="text-truncate">{{ appointmentHistory.branch }}</span>
          <span class="text-truncate">{{
            appointmentHistory.ticketStatus
          }}</span>
        </div>
      </div>
    </div>

    <!-- Enter Remarks -->
    <list-header title="Remarks" />

    <div class="p-3">
      <textarea
        class="form-control style-textarea"
        id="specialRequest"
        rows="5"
        placeholder="Special Request"
      ></textarea>
    </div>

    <!-- Term & Conditions -->
    <list-header title="Terms & Conditions" />

    <div class="style-term-condition d-flex text-start">
      <div class="p-4">
        <p>
          *Cancellation of appointment need to be inform 48hours before the
          appointment.
        </p>
        <p>
          *If you want to cancel the appointment, kindly call our hotline for
          assist.
        </p>
      </div>
    </div>

    <!-- Payment Details -->
    <list-header title="Payment" />

    <div
      class="p-4 style-payment-summary d-flex flex-row"
      style="line-height: 30px"
    >
      <div class="d-flex flex-column scss-bold text-start pe-3">
        <span>Payment Method:</span>
        <!-- <span>Status:</span>
        <span>Voucher:</span> -->
        <template v-if="!hidePriceConditional">
          <span class="scss-text-light-color">Subtotal:</span>
          <span class="scss-text-light-color">Tax:</span>
          <span>Total:</span>
        </template>
      </div>
      <div class="d-flex flex-column text-end flex-grow-1">
        <span>{{ appointmentHistory.paymentMethod }}</span>
        <!-- <span>Paid</span>
        <span>No Voucher</span> -->
        <template v-if="!hidePriceConditional">
          <span>{{
            `${branchCurrencySymbol} ${formatPrice(
              appointmentHistory.servicePrice
            )}`
          }}</span>
          <span>{{
            `${branchCurrencySymbol} ${formatPrice(appointmentHistory.tax)}`
          }}</span>
          <span class="scss-text-blue">{{
            `${branchCurrencySymbol} ${formatPrice(appointmentHistory.total)}`
          }}</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ListHeader from "@/components/ListHeader.vue";
import ItemInfoContainer from "@/components/ItemInfoContainer.vue";

import { formatPrice } from "@/common/helpers/PriceHelper.js";

export default {
  name: "ReviewMyBooking",
  components: {
    ListHeader,
    ItemInfoContainer,
  },
  data() {
    return {
      appointmentHistory: {},
    };
  },
  methods: {
    formatPrice,
  },
  computed: {
    hidePriceConditional() {
      // only hide price if all of the following condition met
      //  1. if wess-legacy > consumer web app > hide service price is Yes
      //  2. booking is book via CWA and not involve payment gateway
      return this.init.hideServicePrice > 0 &&
        (
          this.appointmentHistory.onlineBookingPayment?.ticketId === undefined ||
          this.appointmentHistory.onlineBookingPayment?.ticketId === null
        );
    },
    ...mapGetters(
      [
        "init",
        "branchCurrencySymbol",
      ]
    ),
  },
  created() {
    this.appointmentHistory = JSON.parse(
      sessionStorage.getItem("appointmentHistory")
    );
  },
};
</script>

<style lang="scss" scoped>
.style-term-condition {
  font-size: 12px;
}

.style-textarea {
  resize: none;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}

.style-payment-summary {
  font-size: 16px;
}

textarea:focus {
  outline: none;
  box-shadow: none;
  border-color: $normal-font-color;
}
</style>
